import { render, staticRenderFns } from "./feedbacklist.vue?vue&type=template&id=3525e700&scoped=true&"
import script from "./feedbacklist.vue?vue&type=script&lang=js&"
export * from "./feedbacklist.vue?vue&type=script&lang=js&"
import style0 from "./feedbacklist.vue?vue&type=style&index=0&id=3525e700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525e700",
  null
  
)

export default component.exports